import { config } from "./environment.config";

export const environment = {
  production: true,
  ...config,
  appInsights: {
    instrumentationKey: config.appInsightsKey
  }
};
